import { Component } from '@theme/component';
import { Wishlist } from '@theme/wishlist';

export class WishlistIcon extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.updateState();
    document.addEventListener('wishlist:update', () => this.updateState());
  }

  updateState() {
    const items = Wishlist.getItems();
    if (items.length > 0) {
      this.setAttribute('has-items', '');
    } else {
      this.removeAttribute('has-items');
    }
  }
}

if (!customElements.get('wishlist-icon')) {
  customElements.define('wishlist-icon', WishlistIcon);
}
